import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { array, bool, func, string } from 'prop-types';
import { withRouter } from 'react-router-dom';

import NavigationIcon from 'pages/combineddocs/CombinedDocsNavigation/NavigationIcon';
import strings from 'lang/lang';
import { scrollTo } from 'utils/helpers';
import { navlist } from 'constants/navis';
import { setMenuClose } from 'redux/mobileMenu/mobileMenuActions';
import navigation from './NavigationMenu.module.scss';

const mapStateToProps = (state) => ({
  guidePages: state.ghost.guidePages,
  apiPages: state.info.data,
  sdkPages: state.ghost.sdkPages,
  location: state.router.location,
  sdkPostLoaded: state.ghost.sdkPostLoaded,
  sdkPagesLoaded: state.ghost.sdkPagesLoaded,
  apiPagesLoaded: state.info.loaded,
  guidePostLoaded: state.ghost.guidePostLoaded
});
const mapDispatchToProps = {
  setMenuClose
};

NavigationMenu.propTypes = {
  className: string,
  guidePages: array,
  apiPages: array,
  sdkPages: array,
  setMenuClose: func,
  sdkPostLoaded: bool,
  guidePostLoaded: bool,
  apiPagesLoaded: bool,
  sdkPagesLoaded: bool
};

NavigationMenu.defaultProps = {
  className: 'header',
  apiPages: [],
  sdkPages: [],
};

function NavigationMenu(props) {
  const [delay, setDelay] = useState(200);
  const {
    guidePages,
    apiPages,
    sdkPages,
    history: { push },
    className,
    location,
    setMenuClose,
    guidePostLoaded,
    apiPagesLoaded,
    sdkPostLoaded,
    sdkPagesLoaded
  } = props;
  const pathname = location.pathname;

  useEffect(() => {
    const sidebar = document.getElementById('menu-section');
    const isGuidePage = pathname.indexOf('/docs/guide') != -1;
    const isApis = pathname.indexOf('/docs/apis') != -1;
    const isSdks = pathname.indexOf('/docs/sdks') != -1;

    if (isGuidePage && guidePostLoaded) {
      const secton = document.getElementById('menu-section-guides');
      scrollToSection(sidebar, secton);
    }

    if (isApis && apiPagesLoaded && sdkPagesLoaded) {
      /**
        * @param {sdkPagesLoaded} bool - need to wait SDK so that API section scroll higher
      */
      const secton = document.getElementById('menu-section-apis');
      scrollToSection(sidebar, secton);
    }
    if (isSdks && sdkPostLoaded) {
      const secton = document.getElementById('menu-section-sdks');
      scrollToSection(sidebar, secton);
    }
  }, [location, guidePostLoaded, apiPagesLoaded, sdkPostLoaded, sdkPagesLoaded]);

  function scrollToSection(sidebar, secton) {
    setTimeout(() => {
      scrollTo(sidebar, secton);
    }, delay);
  }

  function onClickLink(c) {
    setDelay(0);
    setMenuClose();
    if (c.id === 1 && guidePages.length) {
      push(c.path + guidePages[0].slug);
    } else if (c.id === 2 && apiPages.length) {
      push(c.path + apiPages[0].id);
    } else if (c.id == 3 && sdkPages.length) {
      push(c.path + sdkPages[0].slug);
    } else {
      push(c.path);
    }
  }

  return (
    <ul>
      {navlist.map((c, i) => {
        const isActive = pathname.indexOf(c.activeInPathname) > -1;
        return (
          <li
            key={i}
            className={cn({
              [navigation[`navigation__${className}`]]: className,
              [navigation[`navigation__${className}--active`]]: isActive,
            })}
            onClick={() => onClickLink(c)}
          >
            <NavigationIcon icon={c.icon} />
            <strong>{strings.header.text[c.name]}</strong>
          </li>
        );
      })}
    </ul>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavigationMenu));
